import React, { useContext, useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow, Tooltip,
} from "@mui/material";
import Moment from "react-moment";
import { DispatchContext } from "../../../store";
import { useNavigate } from "react-router";
import {catalogueAction, catalogueApi} from "../../../services/CatalogueServices";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Notify from "../../../common/Snackbar/Snackbar";
import {DeleteDialog} from "../../../common/Dialog/DeleteDialog";
import {SNACKBAR_OPEN} from "../../../reducers";

const asText = (value) => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "string" || typeof value === "number") return String(value);
  if (typeof value === "object") return value?.name ?? value?.code ?? "-";
  return "-";
};

export default function SearchResultTable({ querySearch, museumId }) {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [artefacts, setArtefacts] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({ total: 0 });
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getUserList();
  }, [querySearch, page, rowsPerPage, museumId]);

  const getUserList = () => {
    catalogueApi("get", null, {
      search: querySearch,
      state: "approved",
      page: page,
      per_page: rowsPerPage,
      museum_id: museumId,
    }).then((res) => {
      setArtefacts(res?.data);
      setMeta(res?.meta);
    });
  };

  const handleChangePage = (event, newPage) => {
    dispatch({ type: "IS_NOT_LOADING", payload: false });
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const artefactDetail = (id) => {
    navigate(`/management/catalogue-artefacts/${id}`);
  };

  const handleDelete = (id, index) => {
    DeleteDialog('Are you sure?', 'Once deleted, you will not be able to recover!').then((willDelete) => {
      if (willDelete) {
        catalogueAction('delete', id).then(res => {
          const updatedItems = artefacts.filter((_, i) => i !== index);
          setArtefacts(updatedItems);
          dispatch({
            type: SNACKBAR_OPEN,
            payload: {isNotify: true, severity: 'success', message: 'Catalogue deleted successfully'}
          });
        }).catch(err => {
          dispatch({
            type: SNACKBAR_OPEN,
            payload: {isNotify: true, severity: 'success', message: {err}}
          })
        });
      }
    });
  };

  return (
    <Box sx={{ mt: 2 }}>
      <TableContainer className={"box-shadow"} component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell align="left" sx={{ color: "#B3B3B3", width: 20 }}>
                Sl.No
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Date of Entry
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Accession No.
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Object Name
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Materials
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Place of Origin
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Cataloged By
              </TableCell>
              <TableCell align="left" sx={{ color: "#B3B3B3" }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {artefacts?.length > 0 &&
              artefacts?.map((artefact, index) => (
                <TableRow hover key={index}>
                  <TableCell align="left" onClick={() => artefactDetail(artefact?.id)} sx={{ color: "#3D3D3D", width: 20 }}>
                    {index + 1}
                  </TableCell>
                  <TableCell onClick={() => artefactDetail(artefact?.id)} sx={{ color: "#3D3D3D" }}>
                    <Moment format={"ll"}>{artefact?.date_of_entry || "-"}</Moment>
                  </TableCell>
                  <TableCell onClick={() => artefactDetail(artefact?.id)} align="left" sx={{ color: "#3D3D3D" }}>
                    {asText(artefact?.accession_no)}
                  </TableCell>
                  <TableCell onClick={() => artefactDetail(artefact?.id)} align="left" sx={{ color: "#3D3D3D" }}>
                    {artefact?.object_name || "-"}
                  </TableCell>
                  <TableCell onClick={() => artefactDetail(artefact?.id)} align="left" sx={{ color: "#3D3D3D" }}>
                    {asText(artefact?.material)}
                  </TableCell>
                  <TableCell onClick={() => artefactDetail(artefact?.id)} align="left" sx={{ color: "#3D3D3D" }}>
                    {asText(artefact?.place_of_origin)}
                  </TableCell>
                  <TableCell onClick={() => artefactDetail(artefact?.id)} align="left" sx={{ color: "#3D3D3D" }}>
                    {artefact?.user_name || "-"}
                  </TableCell>
                  <TableCell align="left" sx={{ color: "#3D3D3D" }}>
                    <Tooltip title={"Delete Catalog"} className={'hand-cursor'}>
                      <IconButton onClick={() => handleDelete(artefact?.id, index)}>
                        <DeleteForeverIcon sx={{color: 'red'}}/>
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 100]}
        page={page - 1}
        rowsPerPage={rowsPerPage}
        component="div"
        count={meta?.total}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}
